var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"red-packet-rain-fade"}},[(_vm.visible)?_c('div',{staticClass:"red-packet-rain",on:{"click":_vm.stop}},_vm._l((_vm.packets),function(item){return _c('ActivityArtwork',{key:item.id,staticClass:"red-packet-rain__item",style:(item.style),attrs:{"name":"envelopeClosed"}})}),1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }